import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeUrlPipe } from 'src/app/pipes/safe-url.pipe';

@Component({
    selector: 'df-pdf-preview',
    templateUrl: './pdf-preview.component.html',
    styleUrls: ['./pdf-preview.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
    imports: [SafeUrlPipe]
})
export class PdfPreviewComponent {
    @Input() pdfUrl: string = '';
    @Input() pdfName: string = '';

    constructor(
        public activeModal: NgbActiveModal
    )
    {

    }
    closeModal(result: boolean) {
        if (this.activeModal) {
            this.activeModal.close(result);
        }
    }

    downloadPDF() {
        if (!this.pdfUrl) return;
        const link = document.createElement('a');
        link.href = this.pdfUrl;
        link.download = this.pdfName || 'document.pdf';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
